module.exports = __webpack_public_path__ + "static/media/triangleBlue.ace6f846.svg";